import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class NotificationsRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getPendingPta() {
    throw new Error('[NotificationsRepository#getPendingPta] must be implemented')
  }
}
